<template>
  <div>
    <div class="tab-menu">
      <div class="tab-item" :class="{active: index == 1}" @click="index = 1">待开始</div>
      <div class="tab-item" :class="{active: index == 2}" @click="index = 2">进行中</div>
      <div class="tab-item" :class="{active: index == 3}" @click="index = 3">已结束</div>
      <div class="tab-item" :class="{active: index == 0}" @click="index = 0" v-if="!isGuide">草稿箱</div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'active',
    event: 'input'
  },
  props: ['active', 'isGuide'],
  data() {
    return {
      
    }
  },
  computed: {
    index: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="stylus" scoped>
  .tab-menu
    width 100%
    height 50px
    line-height 50px
    font-size 15px
    display flex
    .tab-item
      text-align center
      flex 1
      background #ffffff
      &.active
        background #FFF2ED
        color #FF6B31
</style>